/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description getUrlParams
 */

import type { MaybeEmpty } from '@zcode/utility-types'
import { convertQueryStringToParams } from '@zcode/utils'

export const getUrlParams = (
  fromHash = false
): MaybeEmpty<ReturnType<typeof convertQueryStringToParams>> => {
  if (typeof window === 'undefined') {
    return {}
  }
  const query = fromHash ? window.location.hash.substring(1) : window.location.search.substring(1)
  return convertQueryStringToParams(query)
}
